import React, { useEffect, useRef, useState } from "react";
import { Modal, Input, Select, DatePicker, Radio, Button } from "antd";
import dayjs from "dayjs";
import axios from "axios";
import { CREATE_jwel } from "../Config/Config";

const { Option } = Select;

// const stateList = [
//   { state: "ANDHRA PRADESH", code: "37" },
//   { state: "TELANGANA", code: "38" },
// ];

const CustomerDialog = ({
  open,
  onCancel,
  onSave,
  formValues,
  setFormValues,
  deleteCustomerDetailsAPI,
  phoneNo,
  setPhoneNo,
  userDetailsAPI,
  phone1Ref,
  searchRef,
  handleMobileNoKeyDown,
}) => {
  const tenantName = localStorage.getItem("tenantName");
  const mobileRef = useRef(null);
  const cityRef = useRef(null);
  const nameRef = useRef(null);
  const phoneRef = useRef(null);
  const phone2Ref = useRef(null);
  const addressRef = useRef(null);
  const stateRef = useRef(null);
  const gstRef = useRef(null);
  const panRef = useRef(null);
  const idProfRef = useRef(null);
  const dobRef = useRef(null);
  const anniversaryRef = useRef(null);
  const saveRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [stateList, setStateList] = useState([]);

  const stateDetailsAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=STATE_MASTER`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setStateList(data);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  useEffect(() => {
    stateDetailsAPI();
  }, []);

  // const handleChange = (field, value) => {
  //   // Auto-fill state code when state changes
  //   if (field === "state") {
  //     const selected = stateList.find((s) => s.state === value);
  //     setFormValues((prev) => ({
  //       ...prev,
  //       state: value,
  //       stateCode: selected ? selected.code : "",
  //     }));
  //   } else if (field === "address") {
  //     // Split address text area into 4 lines
  //     const lines = value.split("\n");
  //     setFormValues((prev) => ({
  //       ...prev,
  //       address1: lines[0] || "",
  //       address2: lines[1] || "",
  //       address3: lines[2] || "",
  //       address4: lines[3] || "",
  //     }));
  //   } else {
  //     setFormValues((prev) => ({ ...prev, [field]: value }));
  //   }
  // };

  const handleChange = (field, value) => {
    if (field === "state") {
      const selected = stateList.find((s) => s.statename === value);
      setFormValues((prev) => ({
        ...prev,
        state: value,
        stateCode: selected ? selected.statecode : "",
        locationType: selected?.DEAFULTSTATE === true ? "LOCAL" : "OUTSTATION",
      }));
    } else if (field === "address") {
      // Split address text area into 4 lines
      const lines = value.split("\n");
      setFormValues((prev) => ({
        ...prev,
        address1: lines[0] || "",
        address2: lines[1] || "",
        address3: lines[2] || "",
        address4: lines[3] || "",
      }));
    } else {
      setFormValues((prev) => ({ ...prev, [field]: value }));
    }

    // Clear error when user starts typing
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSave = () => {
    const newErrors = {};

    if (!formValues.mobile1.trim()) {
      newErrors.mobile1 = "Mobile number is required";
    } else if (!/^\d+$/.test(formValues.mobile1)) {
      newErrors.mobile1 = "Mobile number must contain only digits";
    } else if (formValues.mobile1.length !== 10) {
      newErrors.mobile1 = "Mobile number must be exactly 10 digits";
    } else if (!/^[6-9]/.test(formValues.mobile1)) {
      newErrors.mobile1 = "Mobile number is not corrected";
    }
    if (!formValues.city.trim()) newErrors.city = "City is required";
    if (!formValues.name.trim()) newErrors.name = "Name is required";
    if (!formValues.state.trim()) newErrors.state = "State is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return; // Stop execution if errors exist
    }

    // If all mandatory fields are filled, call onSave
    onSave(formValues);
    deleteCustomerDetailsAPI(formValues?.mobile1);
  };

  useEffect(() => {
    if (open && mobileRef.current) {
      mobileRef.current.focus();
    }
  }, [open]);

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  return (
    <Modal
      title={
        <strong
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            fontWeight: "bold",
            background: "#BF9264",
            borderRadius: "8px",
            padding: "4px 8px",
          }}
        >
          Customer Details
        </strong>
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      closable={false}
      centered
      width={650}
      bodyStyle={{
        backgroundColor: "#cde1e8",
        border: "1px solid #ccc",
        padding: "5px 5px",
        borderRadius: "8px",
      }}
      maskStyle={{
        backdropFilter: "blur(8px)", // <- this applies the blur effect
        backgroundColor: "rgba(0, 0, 0, 0.2)", // optional: tint the background a little
        padding: "5px 5px",
      }}
      afterOpenChange={(open) => {
        if (open && mobileRef.current) {
          mobileRef.current.focus();
        }
      }}
      // modalRender={(modal) => (
      //   <div
      //     style={{
      //       position: "relative",
      //       backgroundColor: "#cde1e8",
      //       backgroundClip: "padding-box",
      //       border: 0,
      //       borderRadius: "8px",
      //       boxShadow:
      //         "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
      //       pointerEvents: "auto",
      //       // padding: "10px",
      //     }}
      //   >
      //     {modal}
      //   </div>
      // )}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          gap: "5px",
        }}
      >
        {/* 70% Input */}
        <div style={{ width: "70%" }}>
          <Input
            placeholder="Enter Mobile Number"
            ref={phone1Ref}
            autoFocus={true}
            value={phoneNo}
            onFocus={(e) => e.target.select()}
            onKeyDown={handleMobileNoKeyDown}
            onChange={(e) => {
              const value = e.target.value.replace(/[a-zA-Z]/g, "");
              if (value.length <= 10) {
                setPhoneNo(value);
              }
            }}
            style={{ borderRadius: "8px" }}
          />
        </div>

        {/* 30% Button */}
        <div style={{ width: "30%" }}>
          <Button
            style={{
              width: "100%",
              color: "#fff",
              background: "#b27f59",
              borderRadius: "8px",
            }}
            ref={searchRef}
            onClick={() => {
              mobileRef.current.focus();
              if (/^\d{10}$/.test(phoneNo)) {
                userDetailsAPI();
              }
            }}
          >
            Search
          </Button>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          columnGap: "5px",
        }}
      >
        <div>
          <label style={{ color: "#006400" }}>▶ Mobile No. 1</label>
          <Input
            placeholder="Enter Mobile1"
            ref={mobileRef}
            autoFocus={true}
            value={formValues.mobile1}
            onFocus={(e) => e.target.select()}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              if (value.length <= 10) {
                handleChange("mobile1", value);
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, cityRef);
            }}
            style={{ borderRadius: "8px" }}
          />
          {errors.mobile1 && (
            <span style={{ color: "red" }}>{errors.mobile1}</span>
          )}
        </div>

        <div>
          <label style={{ color: "#006400" }}>▶ City</label>
          <Input
            placeholder="Enter City"
            ref={cityRef}
            value={formValues.city}
            onChange={(e) => handleChange("city", e.target.value)}
            style={{ borderRadius: "8px" }}
            onFocus={(e) => e.target.select()}
            onKeyDown={(e) => {
              handleKeyDown(e, nameRef);
            }}
          />
          {errors.city && <span style={{ color: "red" }}>{errors.city}</span>}
        </div>

        <div>
          <label style={{ color: "#006400" }}>▶ Name</label>
          <Input
            placeholder="Enter Name"
            ref={nameRef}
            value={formValues.name}
            onChange={(e) => handleChange("name", e.target.value)}
            style={{ borderRadius: "8px" }}
            onFocus={(e) => e.target.select()}
            onKeyDown={(e) => {
              handleKeyDown(e, phoneRef);
            }}
          />
          {errors.name && <span style={{ color: "red" }}>{errors.name}</span>}
        </div>

        <div>
          <label style={{ color: "#006400" }}>▶ Mobile No. 2</label>
          <Input
            placeholder="Enter Mobile2"
            ref={phoneRef}
            value={formValues.mobile2}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              if (value.length <= 10) {
                handleChange("mobile2", value);
              }
            }}
            style={{ borderRadius: "8px" }}
            onFocus={(e) => e.target.select()}
            onKeyDown={(e) => {
              handleKeyDown(e, phone2Ref);
            }}
          />
        </div>

        <div>
          <label style={{ color: "#006400" }}>▶ Phone No.</label>
          <Input
            placeholder="Enter Phone No."
            ref={phone2Ref}
            value={formValues.phone}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              if (value.length <= 10) {
                handleChange("phone", value);
              }
            }}
            style={{ borderRadius: "8px" }}
            onFocus={(e) => e.target.select()}
            onKeyDown={(e) => {
              handleKeyDown(e, addressRef);
            }}
          />
        </div>

        <div style={{ gridColumn: "1 / span 2" }}>
          <label style={{ color: "#006400" }}>▶ Address</label>
          <Input.TextArea
            rows={4}
            ref={addressRef}
            value={[
              formValues.address1,
              formValues.address2,
              formValues.address3,
              formValues.address4,
            ].join("\n")}
            onChange={(e) => handleChange("address", e.target.value)}
            style={{ borderRadius: "8px" }}
            // ❌ REMOVE this – it breaks Enter key
            // onFocus={(e) => e.target.select()}

            onKeyDown={(e) => {
              // if (e.key === "Enter" && e.ctrlKey) {
              stateRef.current?.focus();
              // }
            }}
          />
        </div>

        <div>
          <label style={{ color: "#006400" }}>▶ State</label>
          <Select
            placeholder="Select State"
            ref={stateRef}
            value={formValues.state}
            onChange={(value) => {
              handleChange("state", value || "");
              setTimeout(() => {
                gstRef?.current?.focus();
              }, 0);
            }}
            style={{ width: "100%", borderRadius: "8px" }}
            allowClear
            onKeyDown={(e) => {
              setTimeout(() => {
                gstRef?.current?.focus();
              }, 0);
            }}
          >
            {stateList.map((item) => (
              <Option key={item.code} value={item.statename}>
                {item.statename}
              </Option>
            ))}
          </Select>
          {errors.state && <span style={{ color: "red" }}>{errors.state}</span>}
        </div>

        <div>
          <label style={{ color: "#006400" }}>▶ Code</label>
          <Input
            value={formValues.stateCode}
            disabled
            style={{ borderRadius: "8px" }}
          />
        </div>

        <div>
          <label style={{ color: "#006400" }}>▶ GSTIN</label>
          <Input
            placeholder="Enter GSTIN"
            ref={gstRef}
            value={formValues.gstin}
            onChange={(e) => handleChange("gstin", e.target.value)}
            style={{ borderRadius: "8px" }}
            onFocus={(e) => e.target.select()}
            onKeyDown={(e) => {
              handleKeyDown(e, panRef);
            }}
          />
        </div>

        <div>
          <label style={{ color: "#006400" }}>▶ PAN No.</label>
          <Input
            value={formValues.panNo}
            ref={panRef}
            onChange={(e) => {
              // Convert to uppercase and restrict to 10 characters
              const value = e.target.value.toUpperCase().slice(0, 10);
              handleChange("panNo", value);
            }}
            placeholder="Enter PAN (e.g. ABCDE1234F)"
            style={{ borderRadius: "8px" }}
            onFocus={(e) => e.target.select()}
            onKeyDown={(e) => {
              handleKeyDown(e, idProfRef);
            }}
          />
        </div>

        <div>
          <label style={{ color: "#006400" }}>▶ ID Proof</label>
          <Select
            ref={idProfRef}
            value={formValues.idProof}
            onChange={(value) => {
              handleChange("idProof", value || "");
              setTimeout(() => {
                dobRef?.current?.focus();
              }, 0);
            }}
            placeholder="Select ID Proof"
            style={{ width: "100%", borderRadius: "8px" }}
            allowClear
            onKeyDown={(e) => {
              setTimeout(() => {
                dobRef?.current?.focus();
              }, 0);
            }}
          >
            <Option value="Aadhar">Aadhar</Option>
            <Option value="DRIVING LICENCE">Driving Licence</Option>
            <Option value="VOTER ID">Voter ID</Option>
            <Option value="PASSPORT">Passport</Option>
          </Select>
        </div>

        <div>
          <label style={{ color: "#006400" }}>▶ D.O.B</label>
          <DatePicker
            ref={dobRef}
            value={formValues.dob ? dayjs(formValues.dob) : null}
            onChange={(date) =>
              handleChange("dob", date ? date.toISOString() : null)
            }
            placeholder="Select D.O.B"
            style={{ width: "100%", borderRadius: "8px" }}
            maxDate={dayjs()}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
            onKeyDown={(e) => {
              handleKeyDown(e, anniversaryRef);
            }}
          />
        </div>

        <div>
          <label style={{ color: "#006400" }}>▶ Anniversary</label>
          <DatePicker
            ref={anniversaryRef}
            value={
              formValues.anniversary ? dayjs(formValues.anniversary) : null
            }
            onChange={(date) =>
              handleChange("anniversary", date ? date.toISOString() : null)
            }
            placeholder="Select Anniversary"
            style={{ width: "100%", borderRadius: "8px" }}
            maxDate={dayjs()}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
            onKeyDown={(e) => {
              handleKeyDown(e, saveRef);
            }}
          />
        </div>

        <div style={{ gridColumn: "1 / span 2", marginTop: "10px" }}>
          <Radio.Group
            onChange={(e) => handleChange("locationType", e.target.value)}
            value={formValues.locationType}
          >
            <Radio value="OUTSTATION">Out Station</Radio>
            <Radio value="LOCAL">Local</Radio>
          </Radio.Group>
        </div>
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: 10,
          display: "flex",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        <Button
          onClick={() => {
            onCancel();
            setErrors({});
          }}
          style={{
            backgroundColor: "#fff",
            border: "1px solid red",
            color: "red",
            borderRadius: "8px",
            width: 100,
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          ref={saveRef}
          onClick={handleSave}
          style={{
            width: 100,
            backgroundColor: "#51BB8F",
            borderRadius: "8px",
          }}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default CustomerDialog;
